import React from 'react';
import { Loader } from 'freemium-ui';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { useGetAuthData } from 'shared/hooks';
import useEventListener from 'shared/hooks/useEventListener';
import { Center, FormContainer, FormHeader } from 'shared/styles';
import { getText } from 'shared/text';
import {
  AccountInfoType,
  AccountUserType,
  BreadcrumpDataType,
  ConfirmationType,
  HostConfigType,
} from 'shared/types';
import { useAccessControl } from 'utils/access-control';
import ThemeList from './ThemeList';
import { StyledDesignThemes } from './style';

const {
  settings: { designThemes },
} = getText('EN');

type DesignThemesProps = {
  setConfirmationData: (
    str: ConfirmationType | React.SetStateAction<ConfirmationType>,
  ) => void;
  accountInfo?: AccountInfoType;
  hostConfig: HostConfigType;
  breadcrumpData?: BreadcrumpDataType;
  currentAccountUser?: AccountUserType;
  setBreadcrumpData?: any;
};

const DesignThemes = ({
  hostConfig,
  setBreadcrumpData,
  breadcrumpData,
}: DesignThemesProps) => {
  const { t } = useTranslation();
  const { role } = useAccessControl();
  const history = useHistory();
  const {
    data: surveyServAuthInfo,
    isLoading,
    isError,
    refetch,
    isFetching,
  } = useGetAuthData();

  const refreshTokenHandler = () => {
    refetch();
  };

  const routeHandler = (data: any) => {
    if (data.detail.path) history.push(data.detail.path);
  };

  const UpdateBreadcrumb = (data: any) => {
    if (setBreadcrumpData)
      if (typeof data.detail === 'function') {
        setBreadcrumpData((old: BreadcrumpDataType) => data.detail(old));
      } else {
        setBreadcrumpData(data.detail);
      }
  };

  useEventListener('survey_mfe:route', routeHandler);
  useEventListener('survey_mfe:breadcrumb', UpdateBreadcrumb);
  useEventListener('survey_mfe:refresh_token', refreshTokenHandler);

  if (isLoading || isFetching) {
    return (
      <Center>
        <Loader size="medium" />
      </Center>
    );
  }

  if (isError) return <Center>{t('empty_state.message.network_error')}</Center>;

  return (
    <StyledDesignThemes>
      <FormContainer
        onSubmit={(e: React.FormEvent) => {
          e.preventDefault();
        }}
      >
        <FormHeader hideBorder>
          <div className="left-pane">
            <div>
              <div className="heading">{`${t(designThemes?.layout?.heading)}  ${
                breadcrumpData?.text !== undefined ? breadcrumpData?.text : ''
              }`}</div>
              <div className="sub-heading">
                {t(designThemes?.layout?.description)}
              </div>
            </div>
          </div>
        </FormHeader>
        <FormContainer>
          <ThemeList
            role={role}
            surveyServAuthInfo={surveyServAuthInfo}
            hostConfig={hostConfig}
            product="freshsurvey"
          />
        </FormContainer>
      </FormContainer>
    </StyledDesignThemes>
  );
};

export default DesignThemes;
